import styled from '@emotion/styled'
import { Divider } from 'shared/ui'

export default styled(Divider)`
  &&& {
    margin-top: auto;
    margin-left: -16px;
    margin-right: -16px;
    border-top: 1px solid ${props => props.theme.color.monochrome.light};
    display: block !important;
  }
`
